import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { UploadImages, UploadImg } from "@/components/UploadImages";

import { addCategory, updateCategory } from "../api";
import { GD, LDA, LH, PK, PLDA, useDetailCategory } from "../util";
import { useListCompany } from "@/modules/companys/company/util";
import { useListCity, useListDistrict, useListWard } from "@/utils";
import { removePropObject } from "@/utils";
import {
  AddForm,
  DropdownForm,
  InputForm,
  InputSwitchForm,
} from "@/components/AddForm";
import { useListInvestor } from "@/modules/investor/util";
import { business_status, progress } from "@/constants";
import Editorz from "@/components/EditorV2";
import { TitlePart } from "@/components/TitlePart";
import { InputNumber } from "@/uiCore";
import { useListExchange } from "@/modules/companys/exchange/util";

const UpdateCategory = () => {
  const { id } = useParams();
  const categoryInfo = useDetailCategory(id);
  const [avatar, setAvatar] = useState("");
  const [images, setImages] = useState([]);
  const [infos, setInfos] = useState({
    cb_code: "",
    alias: "",
    cb_title: "",
    address: "",
    price_from: "",
    price_to: "",
    hidden_cat: true,
  });
  const [data, setData] = useState("");

  useEffect(() => {
    if (Number(id)) {
      let newcategoryInfo = {
        ...infos,
        ...categoryInfo,
        hidden_cat: categoryInfo.hidden_cat === 0 ? false : true,
        price_from: Number(categoryInfo.price_from),
        price_to: Number(categoryInfo.price_to),
        keeping_time:
          categoryInfo.keeping_time === -1 || !categoryInfo.keeping_time
            ? undefined
            : Number(categoryInfo.keeping_time),
      };
      let newArr = [];
      if (categoryInfo.images) {
        try {
          const parsedImages = typeof categoryInfo.images === 'string' ? JSON.parse(categoryInfo.images) : categoryInfo.images;
          if (Array.isArray(parsedImages)) {
            parsedImages.forEach((c) => {
              newArr.push({ preview: c });
            });
            setImages(newArr);
          }
        } catch (err) {
          console.error("Lỗi parse categoryInfo.images:", err);
        }
      }
      setInfos({ ...newcategoryInfo, images: newArr });
      if (categoryInfo.image)
        setAvatar({ ...avatar, preview: categoryInfo.image });
      if (id && categoryInfo.cb_description)
        setData(categoryInfo.cb_description);
    }
  }, [categoryInfo]);

  const handleData = () => {
    let info = {
      ...infos,
      hidden_cat: infos.hidden_cat ? 1 : 0,
      cb_description: data,
      keeping_time: infos.keeping_time ? Number(infos.keeping_time) : -1,
    };
    if (info.images && info.images[0]) {
      const foundElement = info.images.filter((d) =>
        images.some((n) => JSON.stringify(n) === JSON.stringify(d))
      );
      info.images = [];
      if (foundElement && foundElement[0]) {
        foundElement.forEach((f) => {
          info.images.push(f.preview);
        });
      }
    }
    info = {
      ...removePropObject(info, categoryInfo),
      id: categoryInfo.id,
      gallery: images,
      avatar: avatar,
    };
    if (!info.avatar) {
      return "Vui lòng chọn ảnh đại diện dự án";
    }
    if (!infos.cb_code) return "Vui lòng nhập mã dự án";
    if (!infos.alias) return "Vui lòng nhập tên nội bô";
    if (!infos.cb_title) return "Vui lòng nhập tên thương mại";
    if (!infos.company_id) return "Vui lòng chọn công ty phân phối";
    if (!infos.segment) return "Vui lòng chọn phân khúc";
    if (!infos.progress) return "Vui lòng chọn tiến độ dự án";
    if (!infos.business_status) return "Vui lòng chon trạng thái kinh doanh";
    if (!infos.type_product) return "Vui lòng chọn loại hình";
    if (!infos.juridical) return "Vui lòng chọn tình trạng pháp lý";
    if (!infos.type_project) return "Vui lòng chọn loại dự án";
    if (!infos.city_id) return "Vui lòng chọn tỉnh - thành phố";
    if (!infos.district_id) return "Vui lòng chọn quận huyện";
    if (!infos.ward_id) return "Vui lòng chọn phường xã";
    if (!infos.average_price) return "Vui lòng nhập giá trung bình";
    if (!infos.average_square) return "Vui lòng nhập diện tích trung bình";
    if (!infos.contact_person) return "Vui lòng nhập tên người đầu mối";
    if (!infos.contact_phone) return "Vui lòng nhập số điện thoại";
    if (!infos.contact_email) return "Vui lòng nhập email";
    return info;
  };

  const companys = useListCompany();
  const citys = useListCity();
  const districts = useListDistrict(infos.city_id);
  const wards = useListWard(infos.district_id);
  const investors = useListInvestor();
  const customers = useListExchange({
    status: undefined,
    first: undefined,
  });
  return (
    <AddForm
      checkId={Number(id)}
      title="dự án"
      handleData={handleData}
      route={Number(id) ? "/project/update" : "/project/add"}
      actions={{ add: addCategory, update: updateCategory }}
      refreshObjects={[setInfos, setAvatar, setImages]}
    >
      <div style={{ backgroundColor: "#f8f9fa" }} className="card">
        <TitlePart label={"Thông tin dự án"}>
          <div className="col">
            <div className="mb-3 mb-8 mt-6 w-full flex align-items-center">
              <UploadImg
                image={avatar}
                setImage={setAvatar}
                title="Ảnh đại diện (*)"
              />
            </div>
          </div>
          <div className="col">
            <InputForm
              id="cb_code"
              disabled={Number(id)}
              value={infos.cb_code}
              label="Mã dự án (*)"
              onChange={(e) => setInfos({ ...infos, cb_code: e.target.value })}
              type="code"
            />
            <InputForm
              id="alias"
              value={infos.alias}
              label="Tên nội bộ (*)"
              onChange={(e) => setInfos({ ...infos, alias: e.target.value })}
            />
            <InputForm
              id="cb_title"
              value={infos.cb_title}
              label="Tên thương mại (*)"
              onChange={(e) => setInfos({ ...infos, cb_title: e.target.value })}
            />
            <DropdownForm
              label="Công ty phân phối(*)"
              value={infos.company_id}
              options={companys}
              onChange={(e) =>
                setInfos({ ...infos, company_id: e.target.value })
              }
            />
            <DropdownForm
              label="Phân khúc (*)"
              value={infos.segment}
              options={PK}
              onChange={(e) => setInfos({ ...infos, segment: e.target.value })}
            />
            <DropdownForm
              label="Tiến độ dự án (*)"
              value={infos.progress}
              options={progress}
              onChange={(e) => setInfos({ ...infos, progress: e.target.value })}
            />
            <DropdownForm
              label="Trạng thái kinh doanh (*)"
              value={infos.business_status}
              options={business_status}
              onChange={(e) =>
                setInfos({ ...infos, business_status: e.target.value })
              }
            />
          </div>
          <div className="col">
            <DropdownForm
              label="Loại hình (*)"
              value={infos.type_product}
              options={LH}
              onChange={(e) =>
                setInfos({ ...infos, type_product: e.target.value })
              }
            />

            <DropdownForm
              label="Tình trạng pháp lý (*)"
              value={infos.juridical}
              options={PLDA}
              onChange={(e) =>
                setInfos({ ...infos, juridical: e.target.value })
              }
            />
            <DropdownForm
              label="Loại dự án (*)"
              value={infos.type_project}
              options={LDA}
              onChange={(e) =>
                setInfos({ ...infos, type_project: e.target.value })
              }
            />
            <DropdownForm
              label="Tỉnh / TP (*)"
              optionValue="value"
              value={infos.city_id}
              options={citys}
              onChange={(e) => setInfos({ ...infos, city_id: e.target.value })}
              optionLabel="text"
            />
            <DropdownForm
              label="Quận / Huyện (*)"
              optionValue="value"
              value={infos.district_id}
              options={districts}
              onChange={(e) =>
                setInfos({ ...infos, district_id: e.target.value })
              }
              optionLabel="text"
            />
            <DropdownForm
              label="Phường / Xã (*)"
              optionValue="value"
              value={infos.ward_id}
              options={wards}
              onChange={(e) => setInfos({ ...infos, ward_id: e.target.value })}
              optionLabel="text"
            />
            <InputForm
              id="address"
              value={infos.address}
              label="Địa chỉ (*)"
              onChange={(e) => setInfos({ ...infos, address: e.target.value })}
            />
          </div>
        </TitlePart>
        <TitlePart label={"Thông tin giá"}>
          <div className="col">
            <InputForm
              label="Giá trung bình(*)"
              type="number"
              placeholder="Giá trung bình(*)"
              value={infos.average_price}
              className="w-full"
              onChange={(e) =>
                setInfos({ ...infos, average_price: e.target.value })
              }
            />
            <InputForm
              type="number"
              label="Diện tích trung bình(*)"
              placeholder="Diện tích trung bình(*)"
              value={infos.average_square}
              className="w-full"
              onChange={(e) =>
                setInfos({ ...infos, average_square: e.target.value })
              }
            />

            <div className="flex mb-1 change-disabled">
              <label
                htmlFor="fee"
                className="block mt-2 text-900 font-medium w-4 mr-2"
              >
                Tỉ lệ phí
              </label>
              <InputNumber
                id="fee"
                placeholder="Tỉ lệ phí"
                value={infos.fee_rate}
                min={0}
                className="w-full"
                mode="decimal"
                maxFractionDigits={2}
                onValueChange={(e) => setInfos({ ...infos, fee_rate: e.value })}
              />
            </div>
          </div>

          <div className="col">
            <div className="flex">
              <label className="w-5 mt-2 block text-900 font-medium mr-2">
                Khoảng giá (tỷ đồng)(*)
              </label>
              <div className="w-full flex gap-4">
                <InputForm
                  type="number"
                  placeholder="từ"
                  value={infos.price_from}
                  className="w-full"
                  onChange={(e) =>
                    setInfos({ ...infos, price_from: e.target.value })
                  }
                />
                <InputForm
                  type="number"
                  placeholder="đến"
                  value={infos.price_to}
                  className="w-full"
                  onChange={(e) =>
                    setInfos({ ...infos, price_to: e.target.value })
                  }
                />
              </div>
            </div>
            <InputForm
              label="Phân khúc giá (*)"
              value={infos.price_segment}
              onChange={(e) =>
                setInfos({ ...infos, price_segment: e.target.value })
              }
            />
            <InputForm
              type="number"
              label="Phân loại tỉ lệ phí(*)"
              placeholder="Phân loại tỉ lệ phí(*)"
              value={infos.fee_classification}
              className="w-full"
              onChange={(e) =>
                setInfos({ ...infos, fee_classification: e.target.value })
              }
            />
          </div>
        </TitlePart>
        <TitlePart label={"Thông tin chủ đầu tư"}>
          <div className="col">
            <DropdownForm
              label="Chủ đầu tư (*)"
              value={infos.investor_id}
              options={investors}
              onChange={(e) =>
                setInfos({ ...infos, investor_id: e.target.value })
              }
            />
            <InputForm
              label="Tên người đầu mối (*)"
              value={infos.contact_person}
              className="w-full"
              onChange={(e) =>
                setInfos({ ...infos, contact_person: e.target.value })
              }
            />
          </div>
          <div className="col">
            <InputForm
              label="Mã chủ đầu tư (*)"
              value={investors?.find((e) => e?.id == infos.investor_id)?.code}
              readOnly
            />
            <InputForm
              label="Số điện thoại liên hệ (*)"
              value={infos.contact_phone}
              className="w-full"
              onChange={(e) => {
                const onlyNums = e.target.value.replace(/\D/g, "");
                setInfos({ ...infos, contact_phone: onlyNums });
              }}
            />
            <InputForm
              label="Email liên hệ (*)"
              value={infos.contact_email}
              className="w-full"
              onChange={(e) =>
                setInfos({ ...infos, contact_email: e.target.value })
              }
            />
          </div>
        </TitlePart>
        <TitlePart label={"Thông tin đơn vị quản lý"}>
          <div className="col">
            <DropdownForm
              label="Phòng ban (*)"
              value={infos.pb_id}
              options={customers?.filter(
                (e) => e?.company_id == infos?.company_id
              )}
              onChange={(e) => setInfos({ ...infos, pb_id: e.target.value })}
            />
          </div>
          <div className="col">
            <InputForm
              label="Mã chủ đầu tư (*)"
              value={customers?.find((e) => e?.id == infos.pb_id)?.code}
              readOnly
            />
          </div>
        </TitlePart>
        <div className="grid">
          <div className="col"></div>
          <div className="col">
            <InputSwitchForm
              checked={infos.hidden_cat}
              onChange={(e) =>
                setInfos({ ...infos, hidden_cat: e.target.value })
              }
            />
          </div>
        </div>
        {/* <div className="grid formgrid">
          <div className="col-12 lg:col-6">
            <DropdownForm
              label="Giai đoạn (*)"
              value={infos.stage}
              options={GD}
              onChange={(e) => setInfos({ ...infos, stage: e.target.value })}
            />

            <InputNumber
              label="Thời gian giữ căn/chỗ (phút) "
              value={infos.keeping_time}
              className="w-full"
              handleChange={(e) => setInfos({ ...infos, keeping_time: e })}
            />
          </div>
          <div className="col-12 lg:col-6">
            <div className="mb-6">
              <UploadImages
                images={images}
                setImages={setImages}
                title="Slide"
              />
            </div>

            <InputSwitchForm
              checked={infos.hidden_cat}
              onChange={(e) =>
                setInfos({ ...infos, hidden_cat: e.target.value })
              }
            />
          </div>
          <label className="w-12 mt-2 block text-900 font-medium mr-2">
            Mô tả
          </label>
          <div className="w-full" style={{}}>
            <Editorz
              id="content"
              data={infos.content || ""}
              label="Nội dung"
              setData={(e) => setInfos({ ...infos, content: e })}
            />
          </div>
        </div> */}
      </div>
    </AddForm>
  );
};

export default UpdateCategory;
